<template>
  <CContainer :fluid="true">
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader class="d-flex justify-content-between align-items-center">
            <h4 class="mb-0">
              Vagas
            </h4>
            <router-link
              to="/jobs/create"
              class="btn btn-primary d-flex align-items-center"
            >
              <CIcon
                name="cil-library-add"
                class="mr-2"
              />

              Incluir
            </router-link>
          </CCardHeader>

          <CCardBody>
            <CRow>
              <CCol lg="12">
                <Search
                  value=""
                  @search="updateSearch"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol lg="12">
                <DataTable
                  :sorter="query.sorter"
                  :items="datatable.items"
                  :fields="datatable.fields"
                  :enable-export="false"
                  base-route="/jobs/edit/"
                  @sorterValue="event => query.sorter = event"
                  @row-clicked="handleRowClick"
                  @update:checked="updateStatus"
                >
                  <template #actions="{id}">
                    <router-link
                      :to="`jobaplications?job_id=${id}`"
                    >
                      <CIcon
                        v-c-tooltip="'Curriculos'"
                        name="cil-people"
                        class="icon"
                      />
                    </router-link>
                    <DatatableEdit :url="`/jobs/edit/${id}`" />
                    <DatatableRemove
                      @row-clicked="handleRowClick"
                      @deleted="deleteJob"
                    />
                  </template>
                </DataTable>
              </CCol>
            </CRow>
            <CRow class="mt-3">
              <CCol lg="12">
                <Pagination
                  :page="query.page"
                  :per-page="query.perpage"
                  :pages="pagination.pages"
                  :total="pagination.total"
                  :items="pagination.items"
                  @update:active-page="page => query.page = page"
                  @update:perpage="perpage => query.perpage = perpage"
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import DataTable from '@/components/ui/Datatable'
import DatatableEdit from '@/components/ui/DatatableActions/Edit'
import DatatableRemove from '@/components/ui/DatatableActions/Remove'
import Pagination from '@/components/ui/Pagination'
import Search from '@/components/ui/Search'

import JobService from '@/services/job.service'

export default {
  metaInfo: {
    title: 'Projetos',
    titleTemplate: ' %s - Manager - OW Interactive'
  },
  components: {
    DataTable,
    DatatableEdit,
    DatatableRemove,
    Pagination,
    Search
  },

  data () {
    return {
      datatable: {
        items: [],
        fields: [
          {
            key: 'status',
            label: 'Status',
            _style: 'width: 10%'
          },
          {
            key: 'title',
            label: 'Título'
          },
          {
            key: 'level',
            label: 'Nível'
          },
          {
            key: 'localization',
            label: 'Atuação'
          },
          {
            key: 'total_aplications',
            label: 'Nº de candidatos'
          },
          {
            key: 'actions',
            label: 'Ações',
            sorter: false,
            _style: 'width: 10%'
          }
        ]
      },
      query: {
        search: '',
        page: 1,
        perpage: localStorage.getItem('perPageItem') ? parseFloat(localStorage.getItem('perPageItem')) : 10,
        pagination: true,
        status: '',
        sorter: {
          asc: false,
          column: ''
        }
      },
      pagination: {
        total: 0,
        pages: 0,
        items: 0
      },
      rowCliked: {}
    }
  },

  watch: {
    query: {
      handler:
        'updateDataTable',
      deep: true
    }
  },

  async created () {
    await this.updateDataTable()
  },

  methods: {
    async updateDataTable () {
      const response = await JobService.getAll(this.query)
      const { total, lastPage: pages } = response

      if (response.data) {
        this.pagination = {
          total,
          pages,
          items: response.data.length
        }

        const newItems = response.data.map(item => {
          return {
            id: item.id,
            title: item.title,
            level: item.job_level.title,
            localization: item.job_localization.title,
            total_aplications: item.total_aplications,
            status: item.status === 1
          }
        })

        this.datatable.items = newItems
      }
    },

    async updateSearch (searchText) {
      this.query.search = searchText
      this.query.page = 1
      await this.updateDataTable()
    },

    handleRowClick (event) {
      this.rowCliked = event
    },

    async updateStatus (event) {
      const response = await JobService.updateStatus(this.rowCliked, event)

      if (response.status === 200) {
        this.$notify({
          group: 'notifications',
          type: 'success',
          text: 'Status alterado com sucesso'
        })
        await this.updateDataTable()
      } else {
        this.$notify({
          group: 'notifications',
          type: 'error',
          text: 'Ocorreu um erro ao atualizar o status, por favor tente novamente!'
        })
      }
    },

    async deleteJob () {
      const response = await JobService.deleteJob(this.rowCliked)

      if (response.status === 200) {
        this.$notify({
          group: 'notifications',
          type: 'success',
          text: 'Vaga excluída com sucesso!'
        })
      } else {
        this.$notify({
          group: 'notifications',
          type: 'error',
          text: 'Não é possivel excluir a vaga'
        })
      }

      await this.updateDataTable()
    }
  }
}
</script>

<style lang="scss" scoped>
a {
  &:hover {
    color: #3c4b64;
  }
}
.icon {
  margin-right: 15px;
}
</style>
